var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/washing_drying_cleaning_table.template.html');
require('../../libs/handlebars/handlebars-helpers.ts');

var TheView = GenericView.extend({
    el: '#washing_drying_cleaning .table-container',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        var params = {
            appliances: [
                {title: "1. Dishwasher", applianceType: "Dishwasher"},
                {title: "2. Washing machine", applianceType: "Washing_Machine"},
                {title: "3. Tumble dryer", applianceType: "Tumble_Dryer"},
                {title: "4. Electric shower", applianceType: "Electric_Shower"},
                {title: "5. Hair dryer", applianceType: "Hair_Dryer"},
                {title: "6. Hair straightener", applianceType: "Hair_Straightener"},
                {title: "7. Electric shaver", applianceType: "Electric_Shaver_Clipper"},
                {title: "8. Electric toothbrush", applianceType: "Electric_Toothbrush"},
                {title: "9. Ironing machine", applianceType: "Ironing_Machine"},
                {title: "10. Electric water heater", applianceType: "Electric_Water_Heater"},
                {title: "11. Vacuum cleaner", applianceType: "Vacuum_Cleaner"}
            ]
        };

        this.$el.html(this.template(params));
    }
});

module.exports= TheView;